import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-section-template',
  templateUrl: './section-template.component.html',
  styleUrls: ['./section-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
  ],
})
export class SectionTemplateComponent {
}